import locales from './locales';
import * as React from 'react';
import {Result} from "antd";

class Page404 extends React.Component {

  public render() {
    return (
      <div style={{display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%'}}>
        <Result
          status="404"
          title={locales.error}
          subTitle={locales.error404}
        />
      </div>
    );
  }
}

export default Page404;


// WEBPACK FOOTER //
// ./src/Page404.tsx